import React, { Component } from 'react';
import { connect } from 'react-redux';
import './DtcPane.css';
import actions from '../../store/actions';
import ReportAPIs from '../../../src/APIs/ReportAPIs';
import rightArrow from '../../assets/svg/2_arrow.svg';
import downArrow from '../../assets/svg/1_down_arrow.svg';
import Ascending from '../../assets/svg/3_Ascending.svg';
import Descending from '../../assets/svg/4_Descending.svg';
import Ascending_white from '../../assets/svg/Ascending_white.svg';
import Descending_white from '../../assets/svg/Descending_white.svg'
import sort_by from '../../assets/svg/5_sort_by.svg';
import sort_by_selected from '../../assets/svg/6_sort_by_selected.svg';
import active_stamp from '../../assets/svg/7_active_stamp.svg';
import resolved_stamp from '../../assets/svg/8_resolved_stamp.svg';
import moment from 'moment';
import _ from 'lodash';
import { dateFormat } from '../../../src/constants/constants'

class Dtcpane extends Component {
    state = {
        tab: 'ACTIVE_NOW',
        sortBy: 'triggered',
        selectedTime: '1w',
        desc: false,
        sortBox: false,
        data: null

    }
    config = {
        ACTIVE: {
            key: 'ACTIVE',
            title: 'Active ',
        },
        RESOLVED: {
            key: 'RESOLVED',
            title: 'Resoved ',
        },
        ALL: {
            key: 'ALL',
            title: 'All'
        }
    };
    timeTab = {
        firstWeek: {
            key: '1w',
        },
        firstMonth: {
            key: '1m',
        },
        secondMonth: {
            key: '2m',
        },
        thirdMonth: {
            key: '3m',
        },
        sixthMonth: {
            key: '6m',
        },
        oneYear: {
            key: '1y',
        },
    }

    componentDidMount() {
        this.props.dispatch({
            type: actions.DTC_PANE_TAB_CHANGED,
            data: this.config[Object.keys(this.config)[0]]
        })
    }
    componentWillReceiveProps(props) {
        if(props.showDTC && props.showDTC.active){
         this.loadData();
        }
    }
    renderTab() {
        let tabs = Object.keys(this.timeTab);
        let curTime = this.state.selectedTime;
        let type = ['asc', 'desc'];
        let sortByTime = ['triggered', 'resolved']
        return (
            <div className="dptab-details">
                <div className="dptabds-timeSelect">
                    {tabs.map(t => <button onClick={() => this.changeTime(t)} key={t} className={this.timeTab[t].key === this.state.selectedTime ? 'active' : ''}>{this.timeTab[t].key}</button>)}
                    <button onClick={() => this.changeTime('2y')} className={'twoyear' + (this.state.selectedTime === '2y' ? '-active' : '')}>2y</button>
                </div>
                <div className="dptabd-sort">
                    <button className="sort-left" onClick={() => this.sortType()}>Sort by<img src={this.state.sortBox ? downArrow : rightArrow} ></img></button>
                    {
                        this.state.sortBox ? (<div className="sortSelect">
                            <span onClick={() => this.changeSortBy(sortByTime[0])}> <img src={this.state.sortBy === 'triggered' ? sort_by_selected : sort_by}></img>Triger time</span>
                            <span onClick={() => this.changeSortBy(sortByTime[1])}> <img src={this.state.sortBy === 'resolved' ? sort_by_selected : sort_by}></img>resolved time</span>
                        </div>) : ''
                    }
                    <div className="sort-right">
                        <button onClick={() => this.sortTypeChange(type[0])} className={"sortr-btn1" + (!this.state.desc ? 'active' : '')} ><img src={!this.state.desc ? Ascending_white : Ascending}></img> </button>
                        <button onClick={() => this.sortTypeChange(type[1])} className={"sortr-btn2" + (this.state.desc ? 'active' : '')}><img src={this.state.desc ? Descending_white : Descending}></img> </button>
                    </div>
                </div>
            </div>
        )
    }
    sortTypeChange = (type) => {
        let alarms = this.state.data ? this.state.data : null;
        if (type === 'asc') {
            this.setState({ desc: false })
            alarms = _.orderBy(alarms, [this.state.sortBy === 'triggered' ? 'triggered.time' : 'resolved.time'], ['asc']);
            this.setState({
                data: alarms
            })
        }
        if (type === 'desc') {
            this.setState({ desc: true })
            alarms = _.orderBy(alarms, [this.state.sortBy === 'triggered' ? 'triggered.time' : 'resolved.time'], ['desc'])
            this.setState({
                data: alarms
            })
        }
    }

    changeTab = (tab) => {
        this.setState({
            tab: tab,
        })
        this.props.dispatch({
            type: actions.DTC_PANE_TAB_CHANGED,
            data: this.config[tab]
        });
        setTimeout(this.loadData, 500)
    }
    changeTime = (time) => {
        for (let idx in this.timeTab) {
            if (idx === time) {
                this.setState({
                    selectedTime: this.timeTab[idx].key
                })
                setTimeout(this.loadData, 500)
            }
        }
        if (time === '2y') {
            this.setState({
                selectedTime: time,
            })
            setTimeout(this.loadData, 500)
        }
    }
    changeSortBy = (time) => {
        this.state.sortBy != time ? this.setState({
            sortBy: time,
            sortBox: false
        }) : null;
    }
    sortType = () => {
        this.setState({
            sortBox: !this.state.sortBox,
        })
    }
    loadData = (tab) => {
        let today = moment(Date.now());
        let key = this.props.showDTC && this.props.showDTC.tab ? this.props.showDTC.tab.key : this.state.tab;
        let vehicle = window.selectedVehicle && window.selectedVehicle.vehicleid ? window.selectedVehicle.vehicleid : null;
        let starttime = null;
        let endtime = today.unix() * 1000;
        let selectedTime = this.state.selectedTime;
        if (selectedTime === '1w') starttime = today.subtract(7, 'days').unix() * 1000;
        else if (selectedTime === '1m') starttime = today.subtract(30, 'days').unix() * 1000;
        else if (selectedTime === '2m') starttime = today.subtract(60, 'days').unix() * 1000;
        else if (selectedTime === '3m') starttime = today.subtract(90, 'days').unix() * 1000;
        else if (selectedTime === '6m') starttime = today.subtract(180, 'days').unix() * 1000;
        else if (selectedTime === '1y') starttime = today.subtract(365, 'days').unix() * 1000;
        else if (selectedTime === '2y') starttime = today.subtract(730, 'days').unix() * 1000;

        const handleSuccess = (resp) => {
            this.data = resp && resp[0] && resp[0].alarms ? resp[0].alarms : null;
            this.setState({
                data: this.data,
            })
        }
        let body = {
            vehicleid: vehicle,
            starttime: starttime,
            endtime: endtime,
            eventtype: key
        }
        ReportAPIs.getDtcReport(body)
            .then(handleSuccess, (r) => { handleSuccess({}) });
    }

    render() {
        let alarms = this.state && this.state.data != undefined ? this.state.data : null;
        let tabs = Object.keys(this.config);
        let active = this.props.showDTC && this.props.showDTC.active;
        let curTab = this.props.showDTC && this.props.showDTC.tab ? this.props.showDTC.tab.key : null;
        return (
            <div className={'dtcReport' + (active ? ' open' : '')}>
                <div className="dp-tabs">
                    <button onClick={() => this.changeTab(tabs[0])} className={tabs[0] == curTab ? curTab + '-active' : ''}> Active</button>
                    <button onClick={() => this.changeTab(tabs[1])} className={tabs[1] == curTab ? curTab + '-active' : ''}> Resolved</button>
                    <button onClick={() => this.changeTab(tabs[2])} className={tabs[2] == curTab ? curTab + '-active' : ''}> All</button>
                </div>
                <div className="dp-tabv">
                    {this.renderTab()}

                </div>
                <div className="renderDetails">
                    {this.state && this.state.data && this.state.data.length == 0 ?
                    <div className="nodata"><span>No Data</span></div>  : null
                }
                    {this.state && this.state.data != undefined ?
                        alarms.filter(alarm => alarm.resolved && !alarm.resolved.time)
                            .map((item, index) => (
                                <div className="showDetails" key={index}>
                                    <div className="sd-code">
                                        <span className="span1">DTC Code : {item.code}</span>
                                        <div className="sdc-ar">
                                            <img src={active_stamp} ></img>
                                            <span>Active</span>
                                        </div>
                                    </div>
                                    <div className="sd-des">
                                        <span>{item.desc}</span>
                                    </div>
                                    <div className="sd-time">
                                        <span className="sdt-label">Trigger Time :</span> <span className="sdt-time"> {moment(item.triggered.time).format(dateFormat)}</span>
                                    </div>
                                </div>
                            ))
                        : null
                    }
                    {
                        this.state && this.state.data != undefined ?
                            alarms.filter(alarm => alarm.resolved && alarm.resolved.time)
                                .map((item, index) => (

                                    <div className="showDetails" key={index}>
                                        <div className="sd-code">
                                            <span className="span1">DTC Code : {item.code}</span>
                                            <div className="sdc-ar">
                                                <img src={resolved_stamp} ></img>
                                                <span>Resolved</span>
                                            </div>
                                        </div>
                                        <div className="sd-des">
                                            <span>{item.desc}</span>
                                        </div>
                                        <div className="sd-time">
                                            <span className="sdt-label">Trigger Time :</span> <span className="sdt-time"> {moment(item.triggered.time).format(dateFormat)}</span>
                                            <span>|</span>
                                            <span className="sdt-rlabel">Resolved Time :</span> <span className="sdt-time">{moment(item.resolved.time).format(dateFormat)}</span>
                                        </div>
                                    </div>
                                )) : null
                    }
                </div>
            </div>
        )
    }
}

const mapPropsToState = state => {
    return {
        showDTC: state.showDTC,
    }
};

export default connect(mapPropsToState)(Dtcpane);